import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

@Injectable({
    providedIn: 'root',
})
export class HttpService {
    constructor(private http: HttpClient) {}

    public get<T = any>(url: string, params?: HttpParams): Observable<T> {
        return this.http.get(url, { params }) as Observable<T>;
    }

    public post<T>(url: string, payload: any): Observable<T> {
        return this.http.post(url, payload) as Observable<T>;
    }

    public patch<T>(url: string, payload: any): Observable<T> {
        return this.http.patch(url, payload) as Observable<T>;
    }

    public delete<T>(url: string, params?: { [param: string]: string }): Observable<T> {
        return this.http.delete(url, { params }) as Observable<T>;
    }
}
